import { _isNotBlank } from '@/littledash';
import type { ISODate, ISODateTime } from '@/model/Common.model';
import { DateRenderFormat, DateUtils } from '@/utils/Date.utils';

/**
 * Renders the calendar date a study was closed on, preferring the calendar date the user picked
 * (`completed_on` / `canceled_on`) and falling back to the instant the backend recorded
 * (`archived_at` / `canceled_at`) resolved in the study execution timezone.
 *
 * Shared by the study header pill and the completed banner so the two can never show a different
 * date, or the same date in a different format, for the same study.
 */
export const renderStudyClosureDate = (
  closedOn: ISODate | null | undefined,
  closedAt: ISODateTime | null | undefined,
  timezone?: string
): string =>
  _isNotBlank(closedOn)
    ? DateUtils.renderDate(closedOn, { format: DateRenderFormat.Date, defaultResponse: '-' })
    : DateUtils.renderDateTime(closedAt, { format: DateRenderFormat.Date, timezone, defaultResponse: '-' });
